import { takeLatest, all } from 'redux-saga/effects';
import {STATISTICS_PF_DATA_REQ} from "../actionTypes";
import {loadPensionFundDataStats} from "./statisticActions";

export default function* statsSaga() {
  yield all[
      yield takeLatest(STATISTICS_PF_DATA_REQ, loadPensionFundDataStats)
  ];
}
